import { Translations } from '../types/i18n';

export const es: Translations = {
  nav: {
    home: 'Inicio',
    metrics: 'Métricas',
    about: 'Sobre Mí',
    projects: 'Proyectos',
    experience: 'Experiencia & Liderazgo',
    skills: 'Habilidades',
    education: 'Educación & Certificaciones',
    contact: 'Contacto',
    portfolio: 'Jesús Gil'
  },
  hero: {
    greeting: 'Hola, soy',
    viewProjects: 'Explorar Proyectos',
    downloadCV: 'Ver / Descargar CV',
    contactMe: 'Contactar',
    statusAvailable: 'Disponible Presencial/Híbrido en Caracas o 100% Remoto',
    verifiedStats: 'Métricas Verificables'
  },
  sections: {
    metricsTitle: 'Métricas de Impacto',
    metricsSubtitle: 'Rendimiento, actividad algorítmica y contribuciones verificables en tiempo real',
    aboutTitle: 'Sobre Mí',
    aboutSubtitle: 'Ingeniería desde primeros principios, sistemas de alto rendimiento y arquitectura limpia',
    projectsTitle: 'Proyectos Destacados',
    projectsSubtitle: 'Sistemas en producción, motores algorítmicos, dApps y agentes de IA',
    experienceTitle: 'Experiencia, Liderazgo & Logros',
    experienceSubtitle: 'Liderazgo en comunidades tech, competencias ICPC y victorias en hackathones',
    skillsTitle: 'Stack Tecnológico & Habilidades',
    skillsSubtitle: 'Dominio por capas: desde el hardware y sistemas de bajo nivel hasta arquitecturas distribuidas e IA',
    educationTitle: 'Educación Superior & Becas',
    educationSubtitle: 'Formación académica rigurosa y becas de excelencia tecnológica',
    certificationsTitle: 'Certificaciones Profesionales & Idiomas',
    languagesTitle: 'Idiomas',
    contactTitle: 'Contacto & Redes',
    contactSubtitle: 'Conectemos para oportunidades profesionales, proyectos de ingeniería o hackathones'
  },
  projectsFilter: {
    all: 'Todos',
    aiAgents: 'IA & Agentes',
    backendFullstack: 'Backend & Full-Stack',
    web3: 'Web3',
    systemsAlgorithms: 'Sistemas & Algoritmos',
    cybersecurity: 'Ciberseguridad'
  },
  badges: {
    hackathonWinner: '1.er Lugar Hackathon',
    topLatam: 'Top 27 LATAM',
    privateRepo: 'Código Privado / Hackathon',
    verifiedCredential: 'Credencial Verificada'
  },
  buttons: {
    viewLiveDemo: 'Demo en Vivo',
    viewRepository: 'Repositorio',
    verifyCredential: 'Verificar en Credly',
    sendMessage: 'Enviar Mensaje',
    downloadCV: 'Descargar CV (Drive)',
    sourceMetric: 'Verificar Fuente'
  },
  contact: {
    getInTouch: 'Iniciemos una Conversación',
    getInTouchDescription: 'Disponible para roles de Software Engineer (Backend, Full-Stack, Sistemas e IA) o proyectos de alto impacto.',
    contactInfo: 'Información de Contacto',
    socialProfiles: 'Canales & Redes Verificadas',
    location: 'Caracas, Venezuela',
    availability: 'Presencial / Híbrido en Caracas o Remoto Global',
    form: {
      name: 'Tu Nombre',
      email: 'Correo Electrónico',
      subject: 'Asunto / Motivo',
      message: 'Mensaje',
      namePlaceholder: 'Nombre y apellido o empresa',
      emailPlaceholder: 'correo@ejemplo.com',
      subjectPlaceholder: 'Oportunidad laboral, proyecto o colaboración...',
      messagePlaceholder: 'Contame sobre el proyecto, rol o idea...',
      sendButton: 'Enviar Mensaje',
      sendingButton: 'Enviando...',
      successMessage: '¡Mensaje enviado con éxito! Te responderé a la brevedad.',
      privacyText: 'Tus datos solo se usarán para responder a tu mensaje.'
    }
  },
  footer: {
    role: 'Software Engineer | Backend & Full-Stack | Low-Level Systems, Applied AI & Web3',
    builtWith: 'Construido con React, TypeScript y Tailwind CSS. Desplegado en GitHub Pages.',
    allRightsReserved: 'Todos los derechos reservados.',
    backToTop: 'Volver arriba'
  },
  common: {
    loading: 'Cargando...',
    error: 'Ocurrió un error',
    close: 'Cerrar',
    search: 'Buscar...',
    all: 'Todos',
    stars: 'estrellas en GitHub'
  }
};